import React from 'react'

import { Link } from 'gatsby'

import { Highlight } from 'react-instantsearch-dom'

import './Hit.module.sass'

const Hit = ({ hit }) => {
  return (
    <Link to={`/shop/${hit.category}/${hit.slug}`}>
      <p>
        <Highlight attribute="title" hit={hit} />
      </p>
      <img src={hit.mainImage.fluid.src} alt={hit.title} />
    </Link>
  )
}

export default Hit
